<template>
  <div class="wrapper-input-form mx-auto">
    <div class="card shadow-sm p-5 border-0">
      <h2 class="form-section__title">
        <span
          v-for="(item, index) in $root.t('step4.underwritingQuestions')"
          :key="index"
        >
          {{ item }} <br>
        </span>
      </h2>
      <!-- policy holder question-->
      <div
        v-if="$formData.policyDetails.policyHolderInsured"
        class="form-section__group"
      >
        <h4
          v-if="forename !== '' && surname !== ''"
          class="form-section__title"
        >
          <span
            v-for="(item, index) in $root.t('step3.policyHolder')"
            :key="index"
          >
            {{ item }} <br>
          </span>
          - {{ forename }} {{ surname }}
        </h4>
        <h4
          v-else
          class="form-section__title"
        >
          <span
            v-for="(item, index) in $root.t('step3.policyHolder')"
            :key="index"
          >
            {{ item }} <br>
          </span>
        </h4>
        <div class="accordion">
          <div class="accordion-item mb-2 border">
            <AccordionMemberForm
              :underwriting-questions="policyHolderQuestions"
              :prefix="`0_`"
              :title="exchangeTitle()"
              :is-collapse="isCollapse"
            />
          </div>
        </div>
      </div>

      <div
        v-if="familyMembers.length > 0"
        class="form-section__group"
      >
        <h4 class="form-section__title">
          <span
            v-for="(item, index) in $root.t('step3.familyMembers')"
            :key="index"
          >
            {{ item }} ({{ familyMembers.length }}) <br>
          </span>
        </h4>
        <div class="accordion">
          <div
            v-for="(familyData, index) in familyMembers"
            :key="index"
            class="accordion-item mb-2 border"
          >
            <AccordionMemberForm
              :underwriting-questions="familyData.underwritingQuestions"
              :prefix="`${index + 1}_`"
              :title="`${familyData.details.forename} ${familyData.details.surname}`"
              :is-collapse="isCollapse"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AccordionMemberForm from './AccordionMemberForm.vue'
import helper from '../../utils/helper';

export default {
  name: 'UnderwritingQuestions',
  components: {
    AccordionMemberForm,
  },
  props: {
    isCollapse: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      policyHolderQuestions: this.$formData.underwritingQuestions,
      familyMembers: this.$formData.familyMembers,

      forename: this.$formData.policyHolder.details.forename,
      surname: this.$formData.policyHolder.details.surname,
	  currentLocale: this.$locale
    }
  },
  methods: {
	exchangeTitle() {
		return helper.multiLanguageDisplay(this.$root.t('step4.underwritingQuestions'));
	}
  }
}
</script>
